import { FormattedMessage } from 'react-intl';

import { Maintenance } from '@/components/Maintenance/Maintenance';

export const LoginDisabled = () => {
    return (
        <Maintenance message={<FormattedMessage id="page.login.locked.message" />} title={null} />
    );
};
